var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.action + _vm.bookingId},[_c('BookingGroupForm',{attrs:{"action":_vm.action,"booking-id":_vm.bookingId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }